import { ComponentProps, useEffect, useRef, useState } from 'react';
import isServer from '@/utils/isServer';
import fastpanel from '@/utils/fastpanel';
import Script from 'next/script';
import TextInput from '../TextInput';

const hostname = !isServer() ? window.location.hostname.toLowerCase() : '';
const constructorKey =
  hostname.indexOf('www') === 0 ? 'key_p0lWx1n8n5quvnES' : 'key_gW8evXDt8bPKXPEG';

type ConstructorAutocompleteInstance = {
  dispose: () => void;
};

type ConstructorAutocomplete = {
  new (...params: any): ConstructorAutocompleteInstance;
};

function getAutocompleteFromWindow(): ConstructorAutocomplete | undefined {
  // Can't do this do this on the server!
  if (typeof window === 'undefined') return undefined;

  // @ts-expect-error constructor types are not available.
  const fromWindow = window['ConstructorioAutocomplete'] as any;
  return fromWindow;
}

const ConstructorAutocompleteInput = ({
  ...props
}: Omit<ComponentProps<typeof TextInput>, 'ref'>) => {
  const ref = useRef<HTMLInputElement>(null);
  const autocompleteInstanceRef = useRef<ConstructorAutocompleteInstance | null>(null);

  const [ConstructorAutocomplete, setConstructorAutocomplete] = useState(() =>
    getAutocompleteFromWindow()
  );

  // If necessary and we have loaded constructor, initialize the autocomplete instance
  useEffect(() => {
    if (ConstructorAutocomplete && ref.current && !autocompleteInstanceRef.current) {
      autocompleteInstanceRef.current = new ConstructorAutocomplete(ref.current, {
        key: constructorKey,
        maxResultsPerSection: {
          'Search Suggestions': 8,
          Products: 6,
        },
        sectionOrder: ['Search Suggestions', 'Products'],
        htmlStructure: 'product-centric',
        serviceUrl: 'https://pwcdauseo-zone.cnstrc.com',
        onSelect: ({ data }: any) => {
          if (data?.section === 'Products') {
            fastpanel({ name: 'search_auto_complete', data: { comp_id: data.variation_id } });
          }
        },
      });
    }
    return () => autocompleteInstanceRef.current?.dispose();
  }, [ConstructorAutocomplete]);

  return (
    <>
      <Script
        src="https://cnstrc.com/js/cust/paperless-post_NnxtX0.js"
        strategy="lazyOnload" // we want to allow this to lazy-load
        onLoad={() => {
          setConstructorAutocomplete(() => getAutocompleteFromWindow());
        }}
      />
      <TextInput {...props} ref={ref} />
    </>
  );
};

export default ConstructorAutocompleteInput;
